// @flow
import * as React from "react";
import { connect } from "react-redux";
import { Link } from "../common/Link";
import { rgba } from "polished";
import styled from "styled-components";
import Gettext from "../common/Gettext";
import { fontSize, rtl } from "../common/styled-mixins";
import { useBonusTimerStorage, useBonusTimerApi } from "../hooks/useBonusTimer";
import { mapStateToTime } from "../Timers";

import CloseIcon from "@material-ui/icons/CloseOutlined";

const Container = styled.div`
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  height: 26px;
  margin: 10px 15px;
  margin-bottom: 0;
  padding: 0 15px;
  ${rtl("padding-right", "39px")};
  font-size: ${fontSize(12)};
  color: ${({ theme }) => theme.foreground};
  background-color: ${({ theme }) => rgba(theme.foreground, 0.1)};
  border-radius: 4px;
  overflow: hidden;
`;

const Contents = styled(Link)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  height: 24px;
  color: inherit;
  text-decoration: none;
`;

const CloseContainer = styled.div`
  position: absolute;
  top: 0;
  ${rtl("right", 0)};
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 18px;
  color: #919191;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 4;

  :hover {
    color: ${({ theme }) => theme.foreground};
  }
`;

const Percent = styled.strong`
  font-weight: 700;
`;

const Timer = styled.span`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin: 0 auto;
  line-height: 1;
  color: ${({ theme }) => theme.accent};
`;

const Progress = styled.div`
  position: absolute;
  bottom: 0;
  ${rtl("left", 0)};
  height: 2px;
  width: 100%;
  background-color: ${({ theme }) => rgba(theme.foreground, 0.15)};
`;

const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  ${rtl("left", 0)};
  height: 100%;
  background-color: ${({ theme }) => theme.alternativeAccent};
`;

type Props = {
  time: number
};

const BonusTimer = ({ time }: Props) => {
  const [showTimer, toggleTimer] = useBonusTimerStorage();
  const bonus = useBonusTimerApi({ time });

  if (
    showTimer === false ||
    bonus == null ||
    bonus.duration < 0 ||
    bonus.status !== "available"
  ) {
    return null;
  }

  return (
    <Container>
      <Contents to={`/fillup?promocode=${bonus.promo}`}>
        <Gettext>Bonus</Gettext>
        &nbsp;&nbsp;&nbsp;
        <Percent>+{bonus.percent}%</Percent>
        <Timer>{bonus.ticker}</Timer>
      </Contents>
      <CloseContainer onClick={() => toggleTimer(false)}>
        <CloseIcon fontSize="inherit" color="inherit" />
      </CloseContainer>
      <Progress>
        <ProgressBar style={{ width: bonus.progress + "%" }} />
      </Progress>
    </Container>
  );
};

export default connect(mapStateToTime)(BonusTimer);



// WEBPACK FOOTER //
// ./src/components/Trade/BonusTimer.js